import React from "react";
import { Box, Typography } from "@mui/material";
import LinkDisplay from "components/Base/LinkDisplay";

interface RegistrationTabProps {
  registrationLink?: string;
  title?: string;
  helperText?: string;
}

const RegistrationTab: React.FC<RegistrationTabProps> = ({
  registrationLink,
  title = "Registration Details",
  helperText = "Send the following link to guests to register for this event",
}) => {
  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
        {helperText}
      </Typography>

      {registrationLink ? (
        <LinkDisplay
          url={registrationLink}
          openLabel="Registration"
          showCopyButton
          showText
          qrFileName="Registration-qr-code"
          showQrDownloadButton={true}
          showOpenButton
          withBackground
        />
      ) : (
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          No registration link available.
        </Typography>
      )}
    </Box>
  );
};

export default RegistrationTab;